import React from 'react';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { AdPlacementMmaBase } from './mma-ad-placement-base';
import {
  getMmaWideImage4x1Styles,
  getMmaLandScapeImage191x100Styles,
  getMmaSquareImage1x1Styles,
  getMmaVerticalImage1x2Styles,
} from '../styles';

export const AdPlacementMmaWideImage4x1 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl
    showDescription
    showCallToAction
    showAdLabel
    showGradient
    showBusinessName={false}
  />),
  getMmaWideImage4x1Styles,
  { componentName: 'AdPlacementMmaWideImage4x1' }
);

export const AdPlacementMmaLandscapeImage191x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl
    showDescription
    showCallToAction
    showAdLabel
    showGradient={false}
    showBusinessName={false}
    showLogo
  />),
  getMmaLandScapeImage191x100Styles,
  { componentName: 'AdPlacementMmaLandscapeImage191x100' }
);

export const AdPlacementMmaSquareImage1x1 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl
    showDescription
    showCallToAction
    showAdLabel
    showGradient
    showBusinessName={false}
  />),
  getMmaSquareImage1x1Styles,
  { componentName: 'AdPlacementMmaSquareImage1x1' }
);

export const AdPlacementMmaVerticalImage1x2 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl
    showDescription
    showCallToAction
    showAdLabel
    showGradient
    showBusinessName={false}
  />),
  getMmaVerticalImage1x2Styles,
  { componentName: 'AdPlacementMmaVerticalImage1x2' }
);
